import { IconProps } from './types';

export const PotIcon = ({ title = 'Pot Icon', ...props }: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" fill="none" viewBox="0 0 64 64" {...props}>
        <title>{title}</title>
        <path
            fill="#0A2F73"
            d="M18 14.93V12h28v2.93a2 2 0 0 0 .89 1.664l2.438 1.625A6 6 0 0 1 52 23.21V52a4 4 0 0 1-4 4H16a4 4 0 0 1-4-4V23.211a6 6 0 0 1 2.672-4.992l2.437-1.625A2 2 0 0 0 18 14.93"
        ></path>
        <path
            fill="#D9DBDD"
            d="M18 14.93V12h28v2.93a2 2 0 0 0 .89 1.664l2.438 1.625A6 6 0 0 1 52 23.21V35H12V23.211a6 6 0 0 1 2.672-4.992l2.437-1.625A2 2 0 0 0 18 14.93"
        ></path>
        <path fill="#FB0" d="M16 10a2 2 0 0 1 2-2h28a2 2 0 0 1 2 2v4H16z"></path>
        <path
            fill="#fff"
            d="M37.707 44.293 32 38.586l-5.707 5.707a1 1 0 0 0 1.414 1.414L31 42.414V51a1 1 0 1 0 2 0v-8.586l3.293 3.293a1 1 0 0 0 1.414-1.414"
        ></path>
    </svg>
);
